export default "__VITE_ASSET__COKEAhx3__"